import axiosInstance from "./AxiosInstance";

export function getFrequencies(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("frequency/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createFrequency(frequencyData) {
  return axiosInstance.post("frequency/add", frequencyData);
}

export function updateFrequency(frequencyData) {
  return axiosInstance.post("frequency/edit", {
    ...frequencyData,
  });
}

export function deleteFrequency(frequencyId) {
  return axiosInstance.post("frequency/delete", {
    frequency_id: frequencyId,
  });
}

export function formatFrequencies(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((item) => ({
      ...item,
      frequency_id:
        item.frequency_id || item._id || item.id,
    }));
  }

  let list = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      list.push({
        ...responseData[key],
        frequency_id:
          responseData[key].frequency_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return list;
}
